export const types = {
	ADMIN: 1,
	MANAGER: 2,
	USER: 3
};
export default {

	roles: [
		{id: types.ADMIN, text: "admin", rule: "admin"},
		{id: types.MANAGER, text: "מנהל", rule: "client"},
		{id: types.USER, text: "מרכז", rule: "simple"},
	],
	rules: {
		admin: {route: "admin", baseUrl: "api/admin"},
		client: {route: "client", baseUrl: "api/client"},
		simple: {route: "simple"},
	}
};
